import Vue from 'vue';

import { Component } from 'vue-property-decorator';

@Component({
  name: 'bpc-activity-session-attendee-tabs',
  components: {},
})
export default class ActivitySessionAttendeeTabs extends Vue {}
